import React from 'react';

import styles from 'src/icons/RentManager.module.css';

type Props = {
    size?: number;
    className?: string;
};

export default function RentManager({ size = 24, className }: Props) {
    return (
        <img
            src="/img/rentmanager-icon.png"
            alt="RentManager"
            width={size}
            height={size}
            className={className ? `${styles.icon} ${className}` : styles.icon}
        />
    );
}
